// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3n7vm","right":"Footer_right__jzwUk","buttons":"Footer_buttons__d_mhj"};